<script setup lang="ts">
import { computed, ref } from "vue";
import { i18n } from "@/i18n";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import { useConfirmKeys } from "@/composables/useConfirmKeys";

const props = withDefaults(defineProps<{
	title?: string,
	description?: string,
	cancelLabel?: string,
	confirmLabel?: string,
}>(), {
	title: undefined,
	description: '',
	cancelLabel: undefined,
	confirmLabel: undefined,
})

const resolvedTitle = computed(() => props.title ?? String(i18n.global.t('confirm_action_title')))
const resolvedCancelLabel = computed(() => props.cancelLabel ?? String(i18n.global.t('cancel_short')))
const resolvedConfirmLabel = computed(() => props.confirmLabel ?? String(i18n.global.t('confirm_short')))

const emit = defineEmits<{
	(e: 'cancel'): void,
	(e: 'confirm'): void,
}>()

const $root = ref<HTMLElement | null>(null)

useConfirmKeys({
	content: $root,
	cancel: () => emit('cancel'),
	confirm: () => emit('confirm'),
})
</script>

<template>
	<div ref="$root" class="confirm-action">
		<div class="confirm-action__title">
			{{ resolvedTitle }}
		</div>
		<div class="confirm-action__description">
			{{ description }}
		</div>
		<div class="confirm-action__actions">
			<app-button
				class="confirm-action__actions-button"
				type="secondary"
				:label="resolvedCancelLabel"
				@click="emit('cancel')"
			/>
			<app-button
				class="confirm-action__actions-button"
				:label="resolvedConfirmLabel"
				@click="emit('confirm')"
			/>
		</div>
	</div>
</template>

<style scoped lang="scss">
.confirm-action {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	box-sizing: border-box;
	max-width: 232px;
	padding: 12px;
	gap: 8px;

	&__title {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		line-height: 18px;
		font-weight: 600;
		color: #4D4D4D;
	}

	&__description {
		font-size: 14px;
		line-height: 18px;
		color: #4D4D4D;
		text-align: center;
	}

	&__actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;

		&-button {
			flex: 1;
		}
	}
}
</style>
